import { createBrowserRouter } from "react-router-dom";
import { AppLayout } from "../components/Layout/appLayout";
import { AuthLayout } from "../components/Layout/authLayout";
import { insecureRoutes } from "./insecureRoutes";
import HousePage from "../Pages/properties";
import DashboardPage from "../Pages/dashboard";
import TenentsPage from "../Pages/tenents";
import PaymentsPage from "../Pages/payments";
import UsersPage from "../Pages/users";
import PaymentHistory from "../components/PaymentHistory/main";
import ExpensesPage from "../Pages/expenses";
import ApartmentList from "../components/Apartment/card";
import ApartmentPage from "../Pages/ApartmentPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    children: [...insecureRoutes, { path: "", element: <AuthLayout />,children:[	{
      path: '/dashboard',
      element: <DashboardPage/>,
    },{
      path: '/properties',
      element: <HousePage/>,
    },{
      path: '/tenents',
      element: <TenentsPage/>,
    },{
      path: '/payments',
      element: <PaymentsPage/>,
    },
    {
      path: '/payment-history',
      element: <PaymentHistory/>,
    },
     {
      path: '/Apartments',
      element: <ApartmentPage/>,
    }
    ,{
      path: '/users',
      element: <UsersPage/>,
    },
  {
      path: '/expenses',
      element: <ExpensesPage/>,
    }] }],
  },
]);
//payment-history
